import { render } from "./term.vue?vue&type=template&id=4daf04d6&scoped=true"
const script = {}

import "./term.vue?vue&type=style&index=0&id=4daf04d6&lang=less&scoped=true"

import exportComponent from "/Users/imp/work/credit_chkra_ios/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4daf04d6"]])

export default __exports__